// import _ from 'lodash'
import request from '@/utils/request'

const prefix = '/django_rest/user'
const clientAdminPrefix = '/django_rest/client-admin/account'
const clientAdminServiceAccountPrefix = '/django_rest/client-admin/service-account'

export default {
  getUserList (params) {
    return request.get(`${prefix}/`, { params })
  },
  exportUserList (params) {
    return request.get(`${prefix}/list/export/`, { params })
  },
  updateUser (userData) {
    return request.put(`${prefix}/`, userData)
  },
  getUser (params) {
    return request.get(`${prefix}/${params.account_id}/`, { params })
  },
  saveUser (userData) {
    return request.post(`${prefix}/`, userData)
  },
  resetPassword (params) {
    return request.get(`${prefix}/${params.account_id}/reset-password/`)
  },
  userEmailValidate (userData) {
    return request.post(`${prefix}/validate/email/`, userData)
  },
  userMobileValidate (userData) {
    return request.post(`${prefix}/validate/mobile/`, userData)
  },
  getRole (params) {
    return request.get(`${prefix}/role/${params.account_id}/`, { params })
  },
  updateRole (data) {
    return request.put(`${prefix}/role/${data.account_id}/`, data)
  },
  getUserDefaultInfo () {
    return request.get(`${prefix}/select-option/default-info/`)
  },
  resetPasswordByHR (accountId, userData) {
    return request.post(`${prefix}/${accountId}/password/`, userData)
  },
  getResetPasswordPermission (accountId, params) {
    return request.get(`${prefix}/${accountId}/password/`, { params })
  },
  getCancellationAccountByEmailOrMobile (params) {
    return request.get(`${clientAdminPrefix}/`, { params })
  },
  deleteAccount (params) {
    return request.delete(`${clientAdminPrefix}/`, { data: params })
  },
  createServiceAccount (params) {
    return request.post(`${clientAdminServiceAccountPrefix}/`, params)
  },
  checkPasswordExistence (params) {
    return request.get(`${prefix}/check-password-existence/`, { params })
  },
  updatePasswordByUser (params) {
    return request.put(`${prefix}/update-password/`, params)
  }
}
